import { render, staticRenderFns } from "./tabela-planos.vue?vue&type=template&id=d9745e10"
import script from "./tabela-planos.vue?vue&type=script&lang=ts"
export * from "./tabela-planos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports